/**
 * 资金 2FA · 支付密码（P0 资金安全 2026-08-20 + N3 2026-09-04 前端闭环）
 *
 * 后端路由（router.go / handler/user.go）：
 *   GET /api/v1/users/me/payment-password        → data { set: boolean }
 *   PUT /api/v1/users/me/payment-password        → body { payment_password: "123456" }
 *
 * 错误码（service/payment_2fa.go）：
 *   2004 未设置 / 2005 资金操作必传 / 2006 错误 / 2007 连续失败锁定
 * 说明：设置接口无 confirm 字段（契约以 handler/user.go binding 为准，仅需 payment_password 单字段）。
 */
import { get, put } from './http';

/** 支付密码错误码（PRD §12 全集，与后端 service/payment_2fa.go 对齐） */
export const PAYMENT_PASSWORD_ERROR_CODE = {
  NOT_SET: 2004, // 未设置支付密码 → 引导去设置
  REQUIRED: 2005, // 资金操作必须传支付密码（前端校验后一般不会触发）
  WRONG: 2006, // 支付密码错误 → 可重试
  LOCKED: 2007, // 连续失败锁定 → 联系平台 / 稍后再试
} as const;

export type PaymentPasswordErrorCode = (typeof PAYMENT_PASSWORD_ERROR_CODE)[keyof typeof PAYMENT_PASSWORD_ERROR_CODE];

/** 支付密码状态（GET /users/me/payment-password 的 data） */
export interface PaymentPasswordStatus {
  set: boolean;
}

/** 查询当前用户是否已设置支付密码 */
export async function getPaymentPasswordStatus(): Promise<PaymentPasswordStatus> {
  return get<PaymentPasswordStatus>('/users/me/payment-password');
}

/**
 * 设置 / 修改支付密码（6 位数字，前端先行校验）
 * 成功即写入 bcrypt 哈希，同时清零失败计数并解锁（后端 SetPassword 语义）。
 */
export async function setPaymentPassword(paymentPassword: string): Promise<{ ok: boolean }> {
  return put<{ ok: boolean }>('/users/me/payment-password', { payment_password: paymentPassword });
}
